import Store from '~/store'

export default {
    shouldShowStep(step) {
        return Store.getters['ui/getSkipStep'][step] || false
    },

    hideStep(step) {
        Store.dispatch('ui/showSkipStep', { step: step, flag: true })
    },

    showStep(step) {
        Store.dispatch('ui/showSkipStep', { step: step, flag: false })
    },

    resetAllShowSignupSteps() {
        Object.keys(Store.getters['ui/getSkipStep']).forEach((step) => {
            this.showStep(step)
        })
    },
}
